import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { history } from "../../redux/store/configureStore";
import * as clientActions from "../../redux/actions/clientActions";
import NotificationService from "../../services/NotificationService";
import { getById } from "../common/Helpers";
import { formatLedgerAmount } from "./clientLedgerTypes";
import {
  buildManageRouteWithSchoolYear,
  getNormalizedSchoolYearStartYearFromSearch,
} from "./manageSchoolYearRouting";

const NOTIFICATION_TYPE_LABELS = {
  lesson_first_reminder: "Przypomnienie o pierwszych zajeciach",
  lesson_reminder: "Przypomnienie o zajeciach",
  payment_request: "Prosba o platnosc",
  payment_overdue: "Platnosc po terminie",
};

const formatValue = value => value || "-";

const getNotificationTypeLabel = type => NOTIFICATION_TYPE_LABELS[type] || type || "-";

const paymentDetails = notification => (
  notification.amountDue && notification.dueDate
    ? `${formatLedgerAmount(notification.amountDue)} / termin ${notification.dueDate}`
    : "-"
);

export function ClientNotificationHistoryPage({
  clients,
  client,
  loadClients,
  notificationService,
}) {
  const location = useLocation();
  const activeSchoolYearStartYear = getNormalizedSchoolYearStartYearFromSearch(location.search);
  const [notifications, setNotifications] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    if (clients.length === 0) {
      loadClients().catch(loadError => setError(loadError.message));
    }
  }, [clients.length, loadClients]);

  useEffect(() => {
    if (!client.id) return;

    notificationService.getClientNotificationHistory(client.id)
      .then(setNotifications)
      .catch(loadError => setError(loadError.message));
  }, [client.id, notificationService]);

  if (!client.id) {
    return <div className="manage-text">Ladowanie klienta...</div>;
  }

  return (
    <div className="mb-5">
      <h2 className="manage-title">{`Historia powiadomien: ${client.firstName || ""} ${client.lastName || ""}`}</h2>
      {error && <div role="alert" className="alert alert-danger">{error}</div>}
      {notifications.length === 0 ? (
        <div className="manage-text">Brak wysylek powiadomien dla tego klienta.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-sm manage-text">
            <thead>
              <tr>
                <th scope="col">Typ</th>
                <th scope="col">Kanal</th>
                <th scope="col">Status</th>
                <th scope="col">Zaplanowano</th>
                <th scope="col">Wyslano</th>
                <th scope="col">Szczegoly</th>
                <th scope="col">Blad</th>
                <th scope="col">Id dostawcy</th>
              </tr>
            </thead>
            <tbody>
              {notifications.map(notification => (
                <tr key={notification.id}>
                  <td>{getNotificationTypeLabel(notification.notificationType)}</td>
                  <td>{formatValue(notification.channel)}</td>
                  <td>{formatValue(notification.status)}</td>
                  <td>{formatValue(notification.scheduledFor)}</td>
                  <td>{formatValue(notification.sentAt)}</td>
                  <td>{paymentDetails(notification)}</td>
                  <td>{formatValue(notification.error)}</td>
                  <td>{formatValue(notification.providerMessageId)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <button
        type="button"
        className="btn manage-button manage-teal-button mt-3"
        onClick={() => history.push(buildManageRouteWithSchoolYear(`/manage/client/${client.id}`, location.search, activeSchoolYearStartYear))}
      >
        Powrot
      </button>
    </div>
  );
}

ClientNotificationHistoryPage.propTypes = {
  clients: PropTypes.array.isRequired,
  client: PropTypes.object.isRequired,
  loadClients: PropTypes.func.isRequired,
  notificationService: PropTypes.shape({
    getClientNotificationHistory: PropTypes.func.isRequired,
  }),
};

ClientNotificationHistoryPage.defaultProps = {
  notificationService: NotificationService,
};

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps.match.params;
  return {
    clients: state.clients,
    client: getById(state.clients, id) || {},
  };
};

export default connect(mapStateToProps, {
  loadClients: clientActions.loadClients,
})(ClientNotificationHistoryPage);
